<div class="vc-mobile-calendar">
  <ng-template
    #mobileHeaderTemplate
    let-days="days"
    let-trackByWeekDayHeaderDate="trackByWeekDayHeaderDate"
  >
    <div
      class="vc-mobile-calendar__week-header"
      [style.--vc-mobile-calendar-days]="days.length"
    >
      <div
        class="vc-mobile-calendar__week-header-time-spacer"
        aria-hidden="true"
      ></div>
      <button
        *ngFor="let day of days; trackBy: trackByWeekDayHeaderDate"
        type="button"
        class="vc-mobile-calendar__day-chip"
        [class.vc-mobile-calendar__day-chip--today]="day.isToday"
        [class.vc-mobile-calendar__day-chip--active]="
          moment(day.date).isSame(viewDate, 'day')
        "
        (click)="onHeaderDaySelected(day.date)"
      >
        <span>{{ getWeekdayLabel(day.date) }}</span>
        <strong>{{ day.date | date: "d" }}</strong>
      </button>
    </div>
  </ng-template>

  <ng-template
    #mobileHourSegmentTemplate
    let-segment="segment"
    let-segmentHeight="segmentHeight"
    let-isTimeLabel="isTimeLabel"
    let-daysInWeek="daysInWeek"
    let-locale="locale"
  >
    <div
      class="cal-hour-segment vc-mobile-calendar__segment"
      [style.height.px]="segmentHeight"
      [class.cal-hour-start]="segment.isStart"
      [class.cal-after-hour-start]="!segment.isStart"
      [ngClass]="segment.cssClass"
      (pointerdown)="onSegmentPointerDown($event, segment.date, segmentHeight)"
      (pointerup)="onDocumentPointerUp($event)"
      (pointercancel)="onDocumentPointerUp($event)"
      (click)="onSegmentClick($event, segment.date)"
    >
      <div class="cal-time" *ngIf="isTimeLabel">
        {{
          segment.displayDate
            | calendarDate
              : (daysInWeek === 1 ? "dayViewHour" : "weekViewHour")
              : locale
        }}
      </div>
    </div>
  </ng-template>

  <ng-template #mobileEventTemplate let-weekEvent="weekEvent">
    <div
      class="cal-event vc-mobile-calendar__event"
      (pointerdown)="onMobileEventPointerDown($event, weekEvent.event)"
      (pointerup)="onMobileEventPointerUp($event, weekEvent.event)"
      (pointercancel)="onMobileEventPointerCancel($event)"
      (click)="suppressMobileEventClick($event)"
      [class.vc-mobile-calendar__event--selection]="
        weekEvent.event.meta?.mobileSelection
      "
      [ngStyle]="{
        backgroundColor: weekEvent.event.color?.secondary,
        borderLeftColor: weekEvent.event.color?.primary
      }"
    >
      <span class="vc-mobile-calendar__event-time">
        {{ weekEvent.event.start | date: "HH:mm" }}
      </span>
      <span class="vc-mobile-calendar__event-title">
        {{
          weekEvent.event.meta?.mobileSelection
            ? ("APPOINTMENT.MOBILE.SELECTION_LABEL" | translate)
            : weekEvent.event.title
        }}
      </span>
    </div>
  </ng-template>

  <div class="vc-mobile-calendar__toolbar">
    <div class="vc-mobile-calendar__nav">
      <button
        class="vc-mobile-calendar__icon-btn"
        type="button"
        (click)="navigatePrevious()"
      >
        <i class="fas fa-chevron-left"></i>
      </button>

      <button
        class="vc-mobile-calendar__title-btn"
        type="button"
        (click)="mobileDatePicker.toggle($event)"
      >
        <span>{{ mobileTitle }}</span>
        <i class="fas fa-caret-down"></i>
      </button>

      <button
        class="vc-mobile-calendar__icon-btn"
        type="button"
        (click)="navigateNext()"
      >
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>

    <div class="vc-mobile-calendar__actions">
      <button
        class="vc-mobile-calendar__today-btn"
        type="button"
        (click)="goToToday()"
      >
        {{ "COMMON.PERIODS.TODAY" | translate }}
      </button>

      <div class="vc-mobile-calendar__toggle">
        <button
          type="button"
          [class.is-active]="isWeekView"
          (click)="setView(CalendarView.Week)"
        >
          {{ "COMMON.WEEK" | translate }}
        </button>
        <button
          type="button"
          [class.is-active]="isDayView"
          (click)="setView(CalendarView.Day)"
        >
          {{ "COMMON.DAY" | translate }}
        </button>
      </div>

      <button
        *ngIf="!quickMode"
        class="vc-mobile-calendar__icon-btn vc-mobile-calendar__icon-btn--menu"
        type="button"
        (click)="mobileMenu.toggle($event)"
      >
        <i class="fas fa-ellipsis-v"></i>
        <span
          *ngIf="pendingRequestsCount > 0"
          class="vc-mobile-calendar__badge"
        >
          {{ pendingRequestsCount }}
        </span>
      </button>
    </div>
  </div>

  <p-popover #mobileDatePicker styleClass="vc-mobile-calendar__date-popover">
    <p-datepicker
      [(ngModel)]="selectedMobileDate"
      [inline]="true"
      [showButtonBar]="true"
      (onSelect)="onMobileDateSelect($event); mobileDatePicker.hide()"
      (onTodayClick)="goToToday(); mobileDatePicker.hide()"
    ></p-datepicker>
  </p-popover>

  <p-popover #mobileMenu styleClass="vc-mobile-calendar__menu">
    <div class="vc-mobile-calendar__menu-list">
      <button
        *ngIf="hasPermission('CALENDAR_NOTES.CREATE')"
        type="button"
        class="vc-mobile-calendar__menu-item"
        (click)="addNoteMobile(); mobileMenu.hide()"
      >
        <i class="fas fa-sticky-note"></i>
        <span>{{ "CALENDAR.NOTES.ADD" | translate }}</span>
      </button>

      <button
        *ngIf="hasPermission('APPOINTMENTS.UPDATE')"
        type="button"
        class="vc-mobile-calendar__menu-item"
        (click)="toggleRequestsPopover($event); mobileMenu.hide()"
      >
        <i class="fas fa-bell"></i>
        <span>{{ "APPOINTMENT.REQUESTS.PENDING" | translate }}</span>
      </button>

      <button
        *ngIf="!quickMode"
        type="button"
        class="vc-mobile-calendar__menu-item"
        (click)="openSettings?.(); mobileMenu.hide()"
      >
        <i class="fas fa-sliders-h"></i>
        <span>{{ "CALENDAR.SETTINGS.TITLE" | translate }}</span>
      </button>
    </div>
  </p-popover>

  <p-popover
    #pendingRequestsPopover
    styleClass="vc-mobile-calendar__requests-popover"
    appendTo="body"
  >
    <div class="vc-mobile-calendar__requests">
      <header>
        <h4>{{ "APPOINTMENT.REQUESTS.PENDING" | translate }}</h4>
        <span>{{ pendingRequestsCount }}</span>
      </header>

      @if (pendingRequestsLoading) {
        <p>{{ "COMMON.LOADING" | translate }}...</p>
      } @else if (!pendingRequests.length) {
        <p>{{ "APPOINTMENT.REQUESTS.EMPTY" | translate }}</p>
      } @else {
        <div class="vc-mobile-calendar__requests-list">
          @for (appointment of pendingRequests; track appointment.id) {
            <article class="vc-mobile-calendar__request-item">
              <div>
                <strong>{{ getRequestTitle(appointment) }}</strong>
                <small>{{ appointment.start | date: "dd/MM/yyyy HH:mm" }}</small>
                <small *ngIf="getRequestTreatmentNames(appointment)">
                  {{ getRequestTreatmentNames(appointment) }}
                </small>
              </div>
              <div class="vc-mobile-calendar__request-actions">
                <button
                  pButton
                  type="button"
                  class="p-button-text p-button-sm"
                  icon="fas fa-check"
                  (click)="approveRequest(appointment)"
                ></button>
                <button
                  pButton
                  type="button"
                  class="p-button-text p-button-sm p-button-danger"
                  icon="fas fa-times"
                  (click)="rejectRequest(appointment)"
                ></button>
              </div>
            </article>
          }
        </div>
      }
    </div>
  </p-popover>

  <div class="vc-mobile-calendar__body">
    <mwl-calendar-week-view
      [locale]="locale"
      [viewDate]="calendarViewDate"
      [events]="mobileEvents"
      [dayStartHour]="dayStartHour"
      [dayEndHour]="dayEndHour"
      [weekStartsOn]="1"
      [daysInWeek]="daysInView"
      [refresh]="refresh"
      [excludeDays]="[]"
      [hourSegments]="1"
      [hourDuration]="precision"
      [eventSnapSize]="precision"
      [snapDraggedEvents]="false"
      [headerTemplate]="mobileHeaderTemplate"
      [eventTemplate]="mobileEventTemplate"
      [hourSegmentTemplate]="mobileHourSegmentTemplate"
      (dayHeaderClicked)="onHeaderDaySelected($event.day.date)"
      (eventClicked)="onCalendarEventClicked($event.event)"
      (eventTimesChanged)="onMobileEventTimesChanged($event)"
    ></mwl-calendar-week-view>
  </div>

  <section class="vc-mobile-calendar__selection-sheet" *ngIf="selectionChoiceVisible && currentSelection">
    <header>
      <div>
        <span>{{ currentSelection.start | date: "dd/MM/yyyy HH:mm" }}</span>
        <strong>{{ currentSelection.end | date: "HH:mm" }}</strong>
      </div>
      <button type="button" (click)="cancelSelectionChoice()">
        <i class="fas fa-times"></i>
      </button>
    </header>

    <div class="vc-mobile-calendar__selection-actions">
      <button
        type="button"
        class="vc-mobile-calendar__selection-action"
        [disabled]="!hasPermission('APPOINTMENTS.CREATE')"
        (click)="openAppointmentFromSelection()"
      >
        {{ "CALENDAR.TIME_BLOCKS.CREATE_APPOINTMENT" | translate }}
      </button>
      <button
        type="button"
        class="vc-mobile-calendar__selection-action vc-mobile-calendar__selection-action--block"
        [disabled]="!hasPermission('CALENDAR_TIME_BLOCKS.CREATE')"
        (click)="openTimeBlockFormFromSelection()"
      >
        {{ "CALENDAR.TIME_BLOCKS.BLOCK" | translate }}
      </button>
    </div>
  </section>

  <section class="vc-mobile-calendar__selection-sheet" *ngIf="timeBlockFormVisible && currentSelection">
    <header>
      <div>
        <span>{{ currentSelection.start | date: "dd/MM/yyyy HH:mm" }}</span>
        <strong>{{ currentSelection.end | date: "HH:mm" }}</strong>
      </div>
      <button type="button" (click)="cancelSelectionChoice()">
        <i class="fas fa-times"></i>
      </button>
    </header>

    <div class="vc-mobile-calendar__selection-calendars" *ngIf="calendars.length > 1">
      <label>{{ "CALENDAR.TIME_BLOCKS.CALENDARS" | translate }}</label>
      <div>
        <label *ngFor="let calendar of calendars">
          <input
            type="checkbox"
            [checked]="isTimeBlockCalendarChecked(calendar)"
            (change)="toggleTimeBlockCalendar(calendar, $any($event.target).checked)"
          />
          <span>{{ calendar.name }}</span>
        </label>
      </div>
    </div>

    <input
      type="text"
      [(ngModel)]="timeBlockReason"
      [placeholder]="'CALENDAR.TIME_BLOCKS.REASON_PLACEHOLDER' | translate"
    />

    <textarea
      rows="2"
      [(ngModel)]="timeBlockNotes"
      [placeholder]="'CALENDAR.TIME_BLOCKS.NOTES' | translate"
    ></textarea>

    <div class="vc-mobile-calendar__selection-actions">
      <button
        type="button"
        class="vc-mobile-calendar__selection-action"
        (click)="cancelSelectionChoice()"
      >
        {{ "COMMON.CANCEL" | translate }}
      </button>
      <button
        type="button"
        class="vc-mobile-calendar__selection-action vc-mobile-calendar__selection-action--block"
        [disabled]="!selectedTimeBlockCalendarIds.length || savingTimeBlock"
        (click)="createTimeBlockFromSelection()"
      >
        {{ "CALENDAR.TIME_BLOCKS.BLOCK" | translate }}
      </button>
    </div>
  </section>

  <app-calendar-appointments-mobile-form
    *ngIf="drawerVisible"
    [visible]="drawerVisible"
    [selection]="currentSelection"
    [appointment]="editingAppointment"
    [calendarEvent]="editingCalendarEvent"
    [calendars]="calendars"
    [initialPatient]="patient || null"
    [initialTreatments]="treatments ? [treatments] : []"
    (visibleChange)="onDrawerVisibilityChange($event)"
    (saved)="onDrawerSaved()"
    (deleted)="onDrawerSaved()"
  ></app-calendar-appointments-mobile-form>

  <app-reject-appointment-request-dialog
    [visible]="rejectDialogVisible"
    [loading]="rejectRequestWorking"
    [appointment]="rejectTarget"
    [calendars]="calendars"
    [customersId]="customers_id"
    [site]="site"
    (visibleChange)="rejectDialogVisible = $event"
    (submitReject)="confirmRejectRequest($event)"
  ></app-reject-appointment-request-dialog>
</div>
